export const SET_PHARMACY_CONFIG = '@PHARMACY/SET_PHARMACY_CONFIG';


export const setPharmacyConfig = (data) => {
  return (dispatch) => {
    dispatch({ type: SET_PHARMACY_CONFIG, payload: { data } });
  };
};
